import "./App.css";

import DataContextProvider from "./components/DataContext";

import pkjJson from "../package.json";
import { Toaster } from "react-hot-toast";

import RoutesContainer from "./components/RoutesContainer";

// https://hadashboard.woogiu.com/
// top.user_info.openStudentLinkParentPopup()
// https://portaltest.americau.com/
// https://mainbackend.woogiu.com/doc/heroesleague/parent_connector
// Permanent Child Code: 474005
// Phone: +1 666-666-6666 otp: 666666

function App() {
  console.log("Version:", pkjJson.version);

  return (
    <DataContextProvider>
      <RoutesContainer />
      <Toaster position="bottom-center" reverseOrder={false} />
    </DataContextProvider>
  );
}

export default App;
